import { DatePipe } from '@angular/common';
import { UserDateFormat } from 'src/app/model/user';
import { ManagementService } from 'src/app/services/management.service';
import { SearchRequestDto, SortTypeEnum } from 'src/app/shared/search-request-dto';
import { SearchResultContainerDto } from 'src/app/shared/search-result-container-dto';
import { TimeRangeDto } from 'src/app/shared/time-range-dto';
import { NotificationsService } from 'bowman-angular2-notifications';
import { HelperFunctions } from 'bowman-commons';
import { throwError } from 'rxjs';
import { AggregationIntervalsEnum } from './model/aggregation-intervals.enum';
import { AggregationRequestDto } from './model/aggregation-request-dto';
import { AggregationRequestNg } from './model/aggregation-request-ng';
import { AggregationSerie } from './model/aggregation-serie';
import { ChartTypeEnum } from './model/chart-type.enum';
import { FieldMapping } from './model/field-mapping';
import { SearchFilter } from './model/search-filter';
import { SearchOptions } from './model/search-options';
import { DrillDownFilter, DrillDownLevel, SearchRequestNg } from './model/search-request-ng';
import { SearchResult } from './model/search-result';
import { SearchResultContainer } from './model/search-result-container';
import { SearchResultProperty } from './model/search-result-property';
import { UserResponse } from 'algorilla-shared-libs';
import { AllowedGroups as IngestionManagementAllowedGroups } from '../ingestion-management/model/allowed-groups.enum';
import { AllowedGroups as DictionaryAllowedGroups } from '../data-types/dictionary/model/allowed-groups.enum';
import { AllowedGroups as RunActionAllowedGroups } from '../data-types/run-actions/model/allowed-groups.enum';

export class Common {

   public static mergeSearchRequests(inputRequest: SearchRequestNg, contentSearchRequest: SearchRequestNg): SearchRequestNg {
      let outputRequest: SearchRequestNg = HelperFunctions.cloneObject(contentSearchRequest);
      if (!outputRequest.filters) { outputRequest.filters = []; }
      if (!outputRequest.drillDownFilters) { outputRequest.drillDownFilters = []; }
      if (inputRequest.timeRange != null) {
         outputRequest.timeRange = HelperFunctions.cloneObject(inputRequest.timeRange);
      }
      if (inputRequest.typeMapping.length > 0 && inputRequest.timeRange != null) {
         outputRequest.typeMapping = HelperFunctions.cloneObject(inputRequest.typeMapping);
      }
      if (inputRequest.drillDownFilters && inputRequest.drillDownFilters.length > 0) {
         outputRequest.drillDownFilters = HelperFunctions.cloneObject(inputRequest.drillDownFilters);
      }
      if (contentSearchRequest.queryString != null && contentSearchRequest.queryString.trim() != '' && contentSearchRequest.queryString.trim() != '()' && contentSearchRequest.queryString.trim() != '*') {
         outputRequest.queryString = '(' + contentSearchRequest.queryString + ')';
      }
      if (inputRequest.filters && inputRequest.filters.length > 0) {
         inputRequest.filters.forEach(searchFilter => { if (outputRequest.filters) { outputRequest.filters.push(searchFilter) } });
         outputRequest.filters = HelperFunctions.uniqueBy(outputRequest.filters, function (x) { return x.value; });
      }
      if (inputRequest.queryString != null && inputRequest.queryString.trim() != '' && inputRequest.queryString.trim() != '()' && inputRequest.queryString.trim() != '*') {
         let filter: SearchFilter = new SearchFilter();
         filter.value = '(' + inputRequest.queryString.trim() + ')';
         outputRequest.filters.push(filter);
      }
      return outputRequest;
   }

   public static processAggregationSeries(inputSearchRequest: SearchRequestNg, inputAggregationSeries: Array<AggregationSerie>, fieldMappings: { [name: string]: FieldMapping }): AggregationRequestNg {
      try {
         let aggregationRequest: AggregationRequestNg = new AggregationRequestNg();
         inputAggregationSeries.forEach(inputSerie => {
            if (!inputSearchRequest.filters) { inputSearchRequest.filters = []; }
            if (!inputSearchRequest.drillDownFilters) { inputSearchRequest.drillDownFilters = []; }
            if (!inputSerie.filters) { inputSerie.filters = []; }
            let queryElements: Array<string> = [];
            let outputSerie: AggregationSerie = HelperFunctions.cloneObject(inputSerie);
            if (inputSerie.type == ChartTypeEnum.sankey || inputSerie.type == ChartTypeEnum.pie || inputSerie.type == ChartTypeEnum.wordcloud || inputSerie.type == ChartTypeEnum.treemap) {
               outputSerie.timestampField = null;
            }
            if (inputSerie.queryString != null) {
               queryElements.push(inputSerie.queryString);
            }
            if (inputSearchRequest.queryString && inputSearchRequest.queryString != null) {
               queryElements.push(inputSearchRequest.queryString);
            }
            if (inputSearchRequest.timeRange != null) {
               outputSerie.timeRange = HelperFunctions.cloneObject(inputSearchRequest.timeRange);
            }
            if (inputSearchRequest.typeMapping.length > 0) {
               outputSerie.typeMapping = HelperFunctions.cloneObject(inputSearchRequest.typeMapping);
            }

            if (inputSearchRequest.filters && inputSearchRequest.filters.length > 0) {
               inputSearchRequest.filters.map(filter => outputSerie.filters.push(filter));
            }

            if (inputSerie.aggregationKeys.length > 0) {
               for (let key in inputSerie.aggregationKeys) {
                  if (fieldMappings[inputSerie.aggregationKeys[key]] && fieldMappings[inputSerie.aggregationKeys[key]].type == 'text') {
                     outputSerie.aggregationKeys[key] = inputSerie.aggregationKeys[key] + '.keyword';
                  }
               }
            }

            if (inputSerie.options.weightField && inputSerie.options.weightField != null) {
               if (fieldMappings[inputSerie.options.weightField] && fieldMappings[inputSerie.options.weightField].type == 'text') {
                  outputSerie.options.weightField = inputSerie.options.weightField + '.keyword';
               }
            }

            if (inputSerie.drillDownFilter != null) {
               outputSerie.drillDownFilter = HelperFunctions.cloneObject(inputSerie.drillDownFilter);
            }

            if (typeof inputSerie.timestampOffset != 'undefined' && (inputSerie.timestampOffset != null && inputSerie.timestampOffset.trim() != '')) {
               outputSerie.timestampOffsetMs = Common.parseTimestampOffset(inputSerie.timestampOffset);
               outputSerie.timeRange.start = new Date(new Date(outputSerie.timeRange.start).getTime() + outputSerie.timestampOffsetMs);
               outputSerie.timeRange.end = new Date(new Date(outputSerie.timeRange.end).getTime() + outputSerie.timestampOffsetMs);

            }
            let actualDrilldownFilter: DrillDownFilter = new DrillDownFilter();
            if (inputSearchRequest.drillDownFilters && inputSearchRequest.drillDownFilters.length > 0) {
               inputSearchRequest.drillDownFilters.forEach(drilldownFilter => {
                  if (drilldownFilter.serieId == inputSerie.id) {
                     actualDrilldownFilter = HelperFunctions.cloneObject(drilldownFilter);
                  }
               });
            } else {
               actualDrilldownFilter = HelperFunctions.cloneObject(inputSerie.drillDownFilter);

            }

            if (actualDrilldownFilter && actualDrilldownFilter.levels && actualDrilldownFilter.levels.length > 0) {
               actualDrilldownFilter.levels.forEach((level, levelIdx) => {
                  if (level.current && level.keys.length > 0) {
                     outputSerie.aggregationKeys = [];
                     if (levelIdx >= 0 && levelIdx < actualDrilldownFilter.levels.length - 1) {
                        actualDrilldownFilter.levels[levelIdx].keys.forEach((key, keyIdx) => {
                           if (fieldMappings[key] && fieldMappings[key].type == 'text') {
                              outputSerie.aggregationKeys[keyIdx] = key + '.keyword';
                           }
                        });
                     } else if (levelIdx == actualDrilldownFilter.levels.length - 1) {
                        level.keys.forEach((key, keyIdx) => {
                           if (fieldMappings[key] && fieldMappings[key].type == 'text') {
                              outputSerie.aggregationKeys[keyIdx] = key + '.keyword';
                           }
                        });
                     }
                  }
               });
            }

            if (inputSearchRequest.filters && inputSearchRequest.filters.length > 0) {
               inputSearchRequest.filters.forEach(searchFilter => {
                  outputSerie.filters.push(searchFilter);
               })
            }
            if (inputSerie.filters && inputSerie.filters.length > 0) {
               inputSerie.filters.forEach(searchFilter => {
                  outputSerie.filters.push(searchFilter);
               })
            }

            queryElements = queryElements.filter((v, i, a) => a.indexOf(v) === i).filter(v => v.trim() != '').filter(v => v != '()').filter(v => v != '*');
            outputSerie.queryString = queryElements.join(' AND ');
            if (outputSerie.filters && outputSerie.filters.length > 0) {
               outputSerie.filters = HelperFunctions.uniqueBy(outputSerie.filters, function (x) { return x.value; });
            }
            aggregationRequest.series.push(outputSerie);
         });
         return aggregationRequest;
      } catch (err) {
         throw new Error('Cannot process aggregationSerie: ' + err.message);
      }
   }


   public static parseSearchFilters(searchFilters: Array<SearchFilter>): string {
      let filtersList: Array<string> = [];
      let result: string = '';
      searchFilters.forEach(searchFilter => {
         if (!searchFilter.disabled) {
            filtersList.push(searchFilter.negative ? `NOT ${searchFilter.value.trim()}` : searchFilter.value.trim());
         }
      });
      if (filtersList.length == 1) {
         result += `${filtersList.join(' AND ')}`;
      } else if (filtersList.length > 1) {
         result += `(${filtersList.join(' AND ')})`;
      } else {
         result = null;
      }
      return result;
   }

   public static parseTimestampOffset(input: string): number {
      let result: number = 0;
      const regex = /^([-+])?(\d+)([YMdHms])$/;
      const match = regex.exec(input);
      if (regex.test(input)) {
         if (match) {
            const sign: string = match[1]; // Gruppo 1: segno (+ o -)
            const number: number = parseInt(match[2]); // Gruppo 2: numero
            const unit: string = match[3]; // Gruppo 3: unità (Y, M, d, H, m o s)
            switch (unit) {
               case "Y":
                  result = number * (12 * 30 * 24 * 60 * 60 * 1000);
                  break;
               case "M":
                  result = number * (30 * 24 * 60 * 60 * 1000);
                  break;
               case "d":
                  result = number * (24 * 60 * 60 * 1000);
                  break;
               case "H":
                  result = number * (60 * 60 * 1000);
                  break;
               case "m":
                  result = number * (60 * 1000);
                  break;
               case "s":
                  result = number * (1000);
                  break;
            }
            if (sign == '-') {
               return -result;
            } else {
               return result;
            }
         }
      } else {
         throw new Error(`Wrong data format '${input}' for time offset`);
         return null;
      }

   }
   public static marshallSearchRequest(searchRequest: SearchRequestNg, searchOptions: SearchOptions, clientId: string): SearchRequestDto {
      const srDto: SearchRequestDto = new SearchRequestDto();
      srDto.clientId = clientId;
      try {
         let queryParts: string[] = [];      
         queryParts.push((searchRequest.queryString == null || searchRequest.queryString == '' || searchRequest.queryString == '*') ? '' : searchRequest.queryString);
         if (searchRequest.typeMapping.length > 0) {
            searchRequest.typeMapping.forEach(tm => {
               srDto.indexTypes.push(tm.name);
               srDto.timestampMapping[tm.name] = tm.timestampField;
            })
         }
         if (searchRequest && searchRequest.timeRange && searchRequest.timeRange.start && searchRequest.timeRange.end && searchRequest.timeRange.start == searchRequest.timeRange.end) {
            searchRequest.timeRange.start = new Date(new Date(searchRequest.timeRange.start).getTime() - 1000);
            searchRequest.timeRange.end = new Date(new Date(searchRequest.timeRange.end).getTime() + 1000);
         }
         srDto.timeRanges.push(new TimeRangeDto(searchRequest.timeRange.start, searchRequest.timeRange.end));
         if (typeof searchOptions.highlight == 'undefined') {
            srDto.highlight = false;
         }
         srDto.highlight = searchOptions.highlight;
         srDto.size = searchOptions.size;
         srDto.from = searchOptions.from;
         if (searchRequest.typeMapping.length > 0) {
            // srDto.sortField = searchRequest.typeMapping[0].timestampField;
            // srDto.sortType = SortTypeEnum.DESC;
         }
         srDto.timeout = searchOptions.timeout;
         if (searchOptions.sortField) {
            srDto.sortField = searchOptions.sortField;
            srDto.sortType = searchOptions.sortType;
            srDto.timeSort = searchOptions.timeSort;

         }
         srDto.dropActiveSearches = true;
         if (searchRequest.filters && searchRequest.filters.length > 0) {
            let filtersQuery = this.parseSearchFilters(searchRequest.filters);
            queryParts.push(filtersQuery);

         }
         srDto.queryString = queryParts.filter(qp => (qp != null && qp.trim() != '')).join(' AND ');

         return srDto;
      } catch (error) {
         throw new Error("Cannot marshall search request: " + JSON.stringify(error));
      }
   }

   public static marshallAggregationRequest(aggregationSerie: AggregationSerie, searchOptions: SearchOptions, clientId: string): AggregationRequestDto {
      const arDto: AggregationRequestDto = new AggregationRequestDto();
      arDto.clientId = clientId;
      try {
         arDto.queryString = (aggregationSerie.queryString == null || aggregationSerie.queryString == '' || aggregationSerie.queryString == '*') ? '' : aggregationSerie.queryString;
         if (aggregationSerie.typeMapping.length > 0) {
            aggregationSerie.typeMapping.forEach(tm => {
               arDto.indexTypes.push(tm.name);
               arDto.timestampMapping[tm.name] = tm.timestampField;
            })
         }
         if (aggregationSerie.timeRange != null && aggregationSerie.timeRange.start && aggregationSerie.timeRange.end) {
            arDto.timeRanges.push(new TimeRangeDto(aggregationSerie.timeRange.start, aggregationSerie.timeRange.end));
         }
         arDto.highlight = false;
         arDto.size = searchOptions.size;
         arDto.from = searchOptions.from;
         arDto.timeout = searchOptions.timeout;

         for (let key in aggregationSerie.aggregationKeys) {
            arDto.aggregationKeys[parseInt(key)] = aggregationSerie.aggregationKeys[key];
         }

         if (aggregationSerie.metricField && aggregationSerie.metricField != null) {
            arDto.metricField = aggregationSerie.metricField;
            if (aggregationSerie.aggregationType && aggregationSerie.aggregationType != null) {
               arDto.type = aggregationSerie.aggregationType;
            }
         } else {
            arDto.type = null;
         }
         if (arDto.type != null) {
            arDto.types = [arDto.type];
         }

         if (aggregationSerie.weightField && aggregationSerie.weightField != null) {
            arDto.weightField = aggregationSerie.weightField;
            arDto.weighted = true;
         }
         if (aggregationSerie.timestampField && aggregationSerie.timestampField != null) {
            arDto.timestampField = aggregationSerie.timestampField;
            if (aggregationSerie.aggregationInterval && aggregationSerie.aggregationInterval != null) {
               if (aggregationSerie.aggregationInterval == AggregationIntervalsEnum[AggregationIntervalsEnum.Auto]) {
                  arDto.aggregationInterval = AggregationIntervalsEnum[this.getBestAggregationInterval(80, new Date(aggregationSerie.timeRange.start).getTime(), new Date(aggregationSerie.timeRange.end).getTime())];
               } else {
                  arDto.aggregationInterval = AggregationIntervalsEnum[aggregationSerie.aggregationInterval];
               }
            }
         } else {
            arDto.aggregationInterval = 0;
         }
         arDto.dropActiveSearches = true;
         if (aggregationSerie.limit) {
            arDto.size = aggregationSerie.limit;
         }
         if (aggregationSerie.aggregationKeys && aggregationSerie.aggregationKeys.length > 0) {
            arDto.sortType = SortTypeEnum.ASC;
         }
         if (aggregationSerie.filters && aggregationSerie.filters.length > 0) {
            let filtersQuery = this.parseSearchFilters(aggregationSerie.filters);
            if (filtersQuery != null) {
               const baseQuery = (arDto.queryString == null || arDto.queryString.trim() == '' || arDto.queryString.trim() == '*')
                  ? '' : arDto.queryString;
               arDto.queryString = baseQuery ? baseQuery + ' AND ' + filtersQuery : filtersQuery;
            }
         }
         if (aggregationSerie.options.weightField && aggregationSerie.options.weightField != null) {
            arDto.weightSumField = aggregationSerie.options.weightField;
         }
         if (typeof aggregationSerie.sortType != 'undefined') {
            arDto.sortType = aggregationSerie.sortType;
         } else {
            arDto.sortType = SortTypeEnum.DESC;
         }
         if (typeof aggregationSerie.sortField != 'undefined') {
            arDto.sortField = aggregationSerie.sortField;
         } else {
            arDto.sortField = null;
         }
         if (typeof aggregationSerie.rangeField != 'undefined' && aggregationSerie.rangeField != null && typeof aggregationSerie.rangeSteps != 'undefined' && aggregationSerie.rangeSteps != null && aggregationSerie.rangeSteps.length > 0) {
            aggregationSerie.rangeSteps.map(rs => {
               if (rs.from == null) { delete rs.from }
               if (rs.to == null) { delete rs.to }
            })
            arDto.numericRangeField = aggregationSerie.rangeField;
            arDto.range['steps'] = aggregationSerie.rangeSteps;
         }
         return arDto;
      } catch (error) {
         throw new Error("Cannot marshall aggregation request: " + JSON.stringify(error));
      }
   }

   public static getBestAggregationInterval(chartPoints: number, from: number, to: number): string {
      var ratio: number = (to - from) / chartPoints;
      var diff: number = new Date().getTime();
      let best: string;
      Object.keys(AggregationIntervalsEnum).filter(key => !isNaN(Number(AggregationIntervalsEnum[key]))).map(key => {
         if (diff > 0) {
            diff = Math.round(ratio - AggregationIntervalsEnum[key] * 1000);
            best = key;
         }
      });
      return best;
   }
   public static unmarshallResponse(response: SearchResultContainerDto): SearchResultContainer {
      try {
         let src = new SearchResultContainer();
         src.numResults = response.numResults;
         src.pageSize = response.pageSize;
         src.queryTime = response.queryTime;
         src.timedOut = response.timedOut;
         src.canceled = response.canceled;
         src.numberOfShards = response.numberOfShards;
         src.usedTokensNumber = response.usedTokensNumber;
         src.rateLimitEnabled = response.rateLimitEnabled;
         src.tokensRemaining = response.tokensRemaining;
         src.maxBurst = response.maxBurst;
         response.searchResults.forEach(sr => {
            let tmpSr: SearchResult = new SearchResult();
            tmpSr.key = sr.key;
            tmpSr.index = sr.index;
            tmpSr.type = sr.type;
            let parsedMessage: any = null;
            let parsedHighlight: any = null;
            try {
               parsedMessage = JSON.parse(sr.message);
            } catch (parseErr) {
               console.error("Errors occurred parsing message: ", parseErr);
            }
            if (sr.highlight) {
               try {
                  parsedHighlight = JSON.parse(sr.highlight);
               } catch (highlightErr) {
                  console.error("Errors occurred parsing highlight message: ", highlightErr);
               }
            }
            if (parsedMessage != null) {
               for (let key in parsedMessage) {
                  let searchResultProperty: SearchResultProperty;
                  try {
                     if (typeof parsedMessage[key] === "string") {
                        // Faccio il replace dei tag HTML con gli special characters, altrimenti non vengono mostrati in tabella ma interpretati
                        searchResultProperty = new SearchResultProperty(key, parsedMessage[key].replace(/</g, '&lt;').replace(/>/g, '&gt;'));
                     } else {
                        searchResultProperty = new SearchResultProperty(key, parsedMessage[key]);
                     }
                     if (parsedHighlight && parsedHighlight !== null && parsedHighlight[key]) {
                        searchResultProperty.highlight = parsedHighlight[key][0];
                     }
                  } catch (error) {
                     searchResultProperty = new SearchResultProperty(key, 'Errors occurred parsing message: ' + error);
                  }
                  tmpSr.searchResultProperties.push(searchResultProperty);
               }
            }
            src.searchResults.push(tmpSr);
         });
         return src;
      } catch (error) {
         throwError(error);
      }
   }

   public static haveDrillDown(series: Array<AggregationSerie>): boolean {
      let result: boolean = false;
      series.filter(serie => serie.options.drillDownEnabled).map(serie => result = true);
      return result;
   }
   public static haveWidgetDrilldown(series: Array<AggregationSerie>): boolean {
      let result: boolean = false;
      series.filter(serie => serie.drillDownFilter != null).map(serie => result = true);
      return result;
   }
   public static haveSearchFilters(series: Array<AggregationSerie>): boolean {
      let result: boolean = false;
      series.filter(serie => serie.filters != null && serie.filters.length > 0).map(serie => result = true);
      return result;
   }

   public static removeFiltersForTheNextDrillDownLevels(drillDownFilters: Array<DrillDownFilter>, searchFilters: Array<SearchFilter>): Array<SearchFilter> {
      let currentLevel: number = 0;
      let newSearchFilters: Array<SearchFilter> = HelperFunctions.cloneObject(searchFilters);
      drillDownFilters.forEach(ddf => {
         ddf.levels.forEach((level, levelIdx) => {
            if (level.current) {
               currentLevel = levelIdx;
            }
         });
         if (searchFilters && searchFilters.length > 0) {
            ddf.levels.forEach((level, levelIdx) => {
               level.keys.forEach(key => {
                  searchFilters.forEach((searchFilter, searchFilterIdx) => {
                     if (searchFilter.value.indexOf(key) >= 0) {
                        if (levelIdx >= currentLevel && currentLevel != ddf.levels.length - 1) {
                           newSearchFilters.splice(searchFilterIdx, 1);
                        }
                     }
                  });
               });
            });
         }
      });

      return newSearchFilters;
   }
   /**
    * Individua l'eventuale livello di DrillDown e lo setta come current
    * @param serie 
    * @param metricKeys 
    */
   public static parseDrillDownFilters(serie: AggregationSerie, metricKeys: string[]): DrillDownFilter {
      let newDrillDownFilter: DrillDownFilter = null;
      let parsedMetricKeys: Array<string> = [];
      metricKeys.forEach(mk => parsedMetricKeys.push(mk.replace(/.keyword/g, '')));
      if (serie.options.drillDownEnabled && serie.options.drillDownLevels.length > 1) {
         if (serie.drillDownFilter && serie.drillDownFilter != null) {
            newDrillDownFilter = HelperFunctions.cloneObject(serie.drillDownFilter);
         }
         if (!newDrillDownFilter) {
            newDrillDownFilter = new DrillDownFilter();
            newDrillDownFilter.serieId = serie.id;
         }
         if (!newDrillDownFilter.levels) {
            newDrillDownFilter.levels = [];
         }
         serie.options.drillDownLevels.forEach((drillDownLevel, levelIdx) => {
            let newDrillDownLevel: DrillDownLevel = new DrillDownLevel();
            newDrillDownLevel.keys = drillDownLevel;
            if (!newDrillDownFilter.levels[levelIdx]) {
               newDrillDownFilter.levels.push(newDrillDownLevel);
            }
         });
         newDrillDownFilter.levels.map(level => level.current = false);
         newDrillDownFilter.levels.map((level, levelIdx) => {
            if (JSON.stringify(level.keys) == JSON.stringify(parsedMetricKeys)) {
               if (levelIdx < serie.options.drillDownLevels.length - 1) {
                  newDrillDownFilter.levels[levelIdx + 1].current = true;
               } else {
                  newDrillDownFilter.levels[levelIdx].current = true;
               }
            }
         });

      } else {
         newDrillDownFilter = new DrillDownFilter();
         newDrillDownFilter.serieId = serie.id;
         let newDrillDownLevel: DrillDownLevel = new DrillDownLevel();
         newDrillDownLevel.keys = parsedMetricKeys;
         newDrillDownLevel.current = true;
         newDrillDownFilter.levels = [newDrillDownLevel];
      }
      return newDrillDownFilter;
   }
   public static killCurrentSearches(widgetId: string, request: AggregationRequestNg | SearchRequestNg, managementService: ManagementService, notificationService: NotificationsService) {
      let searchIds: Array<string> = [];
      if ((request as AggregationRequestNg) && (request as AggregationRequestNg).series) {
         (request as AggregationRequestNg).series.forEach(s => {
            searchIds.push(widgetId + '___' + HelperFunctions.hashCode(JSON.stringify(s)));
         });
      } else {
         searchIds.push(widgetId);
      }
      managementService.killActiveSearches(searchIds).subscribe(res => {
         if (res.status != 'OK') {
            notificationService.warn("Unable to stop current searches", res.message);
         }
      }, err => {
         notificationService.warn("Unable to stop current searches", err);
      })
   }

   public static initializeDateFormats(datePipe: DatePipe): Array<UserDateFormat> {
      let userDateFormats: Array<UserDateFormat> = [];
      userDateFormats.push(new UserDateFormat('dd/MM/yyyy - HH:mm:ss', datePipe));
      userDateFormats.push(new UserDateFormat('yyyy-MM-dd - HH:mm:ss', datePipe));
      userDateFormats.push(new UserDateFormat('MMM d, yyyy hh:mm:ss a', datePipe));
      userDateFormats.push(new UserDateFormat('MMM d, yyyy HH:mm:ss', datePipe));

      return userDateFormats;
   }
   public static initializeTimeZones(): Array<string> {
      let timeZones: Array<string> = [];
      timeZones = ['Client default', '+0', '+1', '+2', '+3', '+4', '+5', '+6', '+7', '+8', '+9', '+10', '+11', '+12', '-1', '-2', '-3', '-4', '-5', '-6', '-7', '-8', '-9', '-10', '-11', '-12']
      return timeZones;
   }

   public static numberLength(input: number): number {
      return input != null ? input.toString().length : 0;
   }

   public static isCoralineProxyRead(user: UserResponse): boolean {
      let result: boolean = false;
      if (user && user.groups) {
         for (let group in user.groups) {
            if (user.groups[group] === IngestionManagementAllowedGroups.CORALINE_PROXY_READ) {
               result = true;
            }
         }
      }
      return result;
   }
   public static isCoralineProxyAdmin(user: UserResponse): boolean {
      let result: boolean = false;
      if (user && user.groups) {
         for (let group in user.groups) {
            if (user.groups[group] === IngestionManagementAllowedGroups.CORALINE_PROXY_ADMIN) {
               result = true;
            }
         }
      }
      return result;
   }
   public static isDictionaryAdmin(user: UserResponse): boolean {
      let result: boolean = false;
      if (user && user.groups) {
         for (let groupId in user.groups) {
            if (user.groups[groupId] === DictionaryAllowedGroups.DICTIONARY_ADMIN) {
               result = true;
            }
         }
      }
      return result;
   }

   public static isDictionaryEditor(user: UserResponse): boolean {
      let result: boolean = false;
      if (user && user.groups) {
         for (let group in user.groups) {
            if (user.groups[group] === DictionaryAllowedGroups.DICTIONARY_EDITOR) {
               result = true;
            }
         }
      }
      return result;
   }
   public static isRunActionAdmin(user: UserResponse): boolean {
      let result: boolean = false;
      if (user && user.groups) {
         for (let groupId in user.groups) {
            if (user.groups[groupId] === RunActionAllowedGroups.ALARM_TRAY_ADMIN) {
               result = true;
            }
         }
      }
      return result;
   }

   public static isRunActionEditor(user: UserResponse): boolean {
      let result: boolean = false;
      if (user && user.groups) {
         for (let group in user.groups) {
            if (user.groups[group] === RunActionAllowedGroups.ALARM_TRAY_EDITOR) {
               result = true;
            }
         }
      }
      return result;
   }
   public static isUrl(text: string): boolean {
      var expression = '^(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$';
      var regex = new RegExp(expression);
      if (typeof text != 'undefined' && text != null) {
         if (text.toString().match(regex)) {
            return true;
         } else {
            return false;
         }
      } else {
         return false;
      }
   }
   public static sortByFieldCaseInsensitive(arr, field, order = 'asc') {
      // Il metodo .sort() modifica l'array originale. Se non vuoi questo comportamento,
      // crea una copia con [...arr].sort(...)
      return arr.sort((a, b) => {
         // Estrai i valori e assicurati che non siano null o undefined per evitare errori
         const valA = a[field] || '';
         const valB = b[field] || '';

         // Controlla che i valori siano stringhe prima di usare toLowerCase()
         if (typeof valA !== 'string' || typeof valB !== 'string') {
            // Se non sono stringhe, esegui un confronto normale
            return valA < valB ? -1 : 1;
         }

         // --- QUESTA È LA MODIFICA CHIAVE ---
         // Confronta le versioni in minuscolo delle stringhe
         const lowerA = valA.toLowerCase();
         const lowerB = valB.toLowerCase();

         let comparison = 0;
         if (lowerA > lowerB) {
            comparison = 1;
         } else if (lowerA < lowerB) {
            comparison = -1;
         }

         // Inverti il risultato se l'ordine è discendente
         return order === 'desc' ? (comparison * -1) : comparison;
      });
   }
}
